import React from 'react'

export default function LoadingChart({ type }) {
    return (
        <div className={type === 'desktop' ? 'popup-chart-loader' : 'dashboard-chart-loader'}>
            <img style={{ width: '35px' }} src="/loader.gif" alt="loader" />
        </div>
    )
}
